
export interface EventTheme {
  key: string;
  startDate: string; // YYYY-MM-DD
  endDate: string;   // YYYY-MM-DD
  gifPath: string;
}

export const eventThemes: EventTheme[] = [
  {
    key: 'christmas',
    startDate: '2025-12-01',
    endDate: '2025-12-26',
    gifPath: '/images/logo-christmas.svg',
  },
  {
    key: 'newYear',
    startDate: '2025-12-30',
    endDate: '2026-01-02',
    gifPath: '/images/logo-new-year.svg',
  },
  {
    key: 'halloween',
    startDate: '2025-10-30',
    endDate: '2025-11-01',
    gifPath: '/images/logo-halloween.svg',
  },
  // Ajoutez d'autres événements ici
];

export const defaultTheme = {
  gifPath: "/images/logo.svg", // Le logo par défaut
};
